<script setup lang="ts">
import type { BaseActionWithClick } from '@gat-ship/types'
import { computed } from 'vue'
import { GatButton } from '../../gat-button'
import { GatIcon } from '../../gat-icon'

export interface DataTableCellPopoverActionsProps {
  actions?: BaseActionWithClick[]
}

const props = defineProps<DataTableCellPopoverActionsProps>()

const _actions = computed(() => props.actions ?? [])
</script>
<template>
  <div v-if="_actions.length > 0" class="mb-2 flex flex-col border-t">
    <gat-button
      v-for="action in _actions"
      :key="action.label"
      class="w-full rounded-none"
      variant="ghost"
      @click="action.onClick"
    >
      <div class="flex grow items-start gap-1">
        <gat-icon v-if="action.icon" :icon="action.icon" />
        {{ action.label }}
      </div>
    </gat-button>
  </div>
</template>
